import {React} from 'common'
import SearchBar from 'components/Control/SearchBar'
import {Box} from '@mui/material'
import UseSearchArea from 'logic/Search/UseSearchArea'

const SearchArea = ({
    handleMobileSearchMenuOpen,
    isFlex,
    open,
    dances,
    isLoading,
}) => {
    const {goToDance, searchBarSx, searchBoxSx, inputText, noOptionsText} =
        UseSearchArea({
            isFlex,
            open,
        })
    return (
        <>
            <Box sx={searchBoxSx}>
                <SearchBar
                    onClick={handleMobileSearchMenuOpen}
                    data={dances}
                    noOptionsLabel={noOptionsText}
                    isLoading={isLoading}
                    textField={inputText}
                    sx={searchBarSx}
                    onChange={(event, value) => goToDance(value)}
                />
            </Box>
        </>
    )
}

export default SearchArea
